<template>
<div>
  <button
    ref="button"
    :class="lang === 'zh' ? 'reserve-button-zh' : 'reserve-button-en'"
    data-toggle="modal" data-target=".bs-reserve-modal"
  >
  </button>
  <!-- 预约留言 -->
  <div class="modal fade bs-reserve-modal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h1>{{$t('imagewall.bookingTitle')}}</h1>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="modal-body">
          <form>
            <div class="form-group ">
              <input type="text" class="form-control bg-body" :placeholder="$t('imagewall.bookingContacts')" v-model="form.name">
            </div>
            <div class="form-group ">
              <input type="text" class="form-control bg-body" :placeholder="$t('imagewall.bookingPhoneNum')" v-model="form.mobile">
            </div>
            <div class="form-group input-group">
              <input type="text" class="form-control bg-body" :placeholder="$t('imagewall.bookingSmscode')" aria-describedby="basic-addon2" v-model="form.smsCode">
              <div class="input-group-append">
                <button type="button" class="btn btn-warning btn-lg" id="basic-addon2"
                  v-if="!sendMsgDisabled" v-on:click="getSMSCode">{{$t('imagewall.bookingGetSmscode')}}</button>
                <button type="button" class="btn btn-warning btn-lg" id="basic-addon2" disabled
                  v-if="sendMsgDisabled">{{ time + $t('imagewall.bookingRetrySmscode') }}</button>
              </div>
            </div>
            <div class="form-group ">
              <input type="text" class="form-control bg-body" :placeholder="$t('imagewall.bookingCompany')" v-model="form.company">
            </div>
            <div class="form-group ">
              <textarea type="text" class="form-control bg-body" clos="50" rows="3" warp="virtual" :placeholder="$t('imagewall.bookingDetail')" v-model="form.message"/>
            </div>
            <button type="button" v-on:click="submitReserve" class="btn btn-warning btn-lg w-100">{{$t("imagewall.bookingSubmit")}}</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
   
</template>

<script>
import Vue from 'vue'

export default {
  data: () => ({
    lang: i18n.locale || 'zh',
    form: {
      activity:'',
      name:'',
      mobile:'',
      company:'',
      smsCode:'',
      message:'',
    },
    sendMsgDisabled: false,
    time: 60//发送验证码倒计时
  }),
  props: {
    imageWall: Object
  },
  methods: {
    submitReserve() {
      if(this.form.name == "" || this.form.mobile == "" || this.form.smsCode == ""){
        alert(i18n.t("message.noUser"))
      } else {
        this.form.activity = this.$route.params.id
        Vue.axios.post('/user/submit',this.form).then((res)=>{
          this.form.name=''
          this.form.mobile=''
          this.form.company=''
          this.form.smsCode=''
          this.form.message=''
          alert(i18n.t("message.bookingSuccess"))
        }).catch((err)=>{
          alert(i18n.t("message.bookingFailed"))
        });
      }
    },
    getSMSCode(){
      var myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/; 
      if(!myreg.test(this.form.mobile.trim())) {
          alert(i18n.t("message.phoneNumInvalid"))
      }else{
        this.form.mobile = this.form.mobile.trim()
        let me = this;
        me.sendMsgDisabled = true;
        let interval = window.setInterval(function() {
          if ((me.time--) <= 0) {
          me.time = 60;
          me.sendMsgDisabled = false;
          window.clearInterval(interval); //停止
          }
        }, 1000);
        let data = {'mobile':this.form.mobile}
        Vue.axios.post('/user/sendsms',data)
          .then (res=>	{
            if (res.status==200){
              //this.tips="验证码已发送"
            }
          })
      }
    },
  }
}
</script>
